import React from 'react';
import styled from 'styled-components';
import { SubtractIcon, AddIcon } from '@parchment/icons';
import { CircleButton, boulder, java, thunderBird } from '@parchment/atoms';
import { FONT_SIZES, SCALE } from '../../utils/constants';
const FieldList = _ref => {
  let {
    values,
    setValues,
    scale = SCALE.medium,
    addMessage = 'Add Another',
    subtractMessage,
    min = 1,
    max,
    showCount = true,
    onChange,
    render
  } = _ref;
  return /*#__PURE__*/React.createElement(FieldListWrapper, {
    scale: scale
  }, values.map((item, index) => {
    return /*#__PURE__*/React.createElement(FieldContainer, {
      key: index
    }, /*#__PURE__*/React.createElement(InputContainer, null, render({
      item,
      index,
      values
    })), (values.length > min || !min) && /*#__PURE__*/React.createElement(AddRemoveButton, {
      scale: scale,
      onClick: () => {
        setValues(values.filter((val, i) => i !== index));
        onChange({
          index
        });
      }
    }, /*#__PURE__*/React.createElement(CircleButton, {
      "aria-label": "Remove Item",
      noBorder: true,
      scale: scale,
      name: `remove-item-${index}`,
      context: "error",
      ghost: true
    }, /*#__PURE__*/React.createElement(SubtractIcon, null)), subtractMessage && /*#__PURE__*/React.createElement(SubtractMessage, {
      scale: scale
    }, subtractMessage)));
  }), /*#__PURE__*/React.createElement(AddContainer, {
    scale: scale
  }, (!max || values.length < max) && /*#__PURE__*/React.createElement(AddRemoveButton, {
    scale: scale,
    onClick: () => onChange({
      index: -1
    })
  }, /*#__PURE__*/React.createElement(CircleButton, {
    "aria-label": "Add Item",
    noBorder: true,
    scale: scale,
    name: "add-item",
    context: "default",
    onClick: () => undefined,
    ghost: true
  }, /*#__PURE__*/React.createElement(AddIcon, null)), addMessage && /*#__PURE__*/React.createElement(AddMessage, {
    scale: scale
  }, addMessage)), /*#__PURE__*/React.createElement(CurrentMaxContainer, {
    scale: scale
  }, max && showCount ? `(${values.length}/${max})` : '')));
};
export default FieldList;
const FieldListWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "FieldList__FieldListWrapper",
  componentId: "sc-140c85s-0"
})(["font-size:", ";"], _ref2 => {
  let {
    scale
  } = _ref2;
  return FONT_SIZES[scale];
});
const FieldContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "FieldList__FieldContainer",
  componentId: "sc-140c85s-1"
})(["width:100%;margin-bottom:.5em;display:flex;align-items:center;"]);
const InputContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "FieldList__InputContainer",
  componentId: "sc-140c85s-2"
})(["width:100%;"]);
const AddRemoveButton = /*#__PURE__*/styled.div.withConfig({
  displayName: "FieldList__AddRemoveButton",
  componentId: "sc-140c85s-3"
})(["height:50px;padding:0 .5em;display:flex;align-items:center;cursor:pointer;& > div{margin-left:5px;}svg{transition:.2s transform;}&:hover{& > div{text-decoration:underline;}}"]);
const AddMessage = /*#__PURE__*/styled.div.withConfig({
  displayName: "FieldList__AddMessage",
  componentId: "sc-140c85s-4"
})(["font-weight:600;display:inline-block;color:", ";font-size:", ";"], java, _ref3 => {
  let {
    scale
  } = _ref3;
  return FONT_SIZES[scale];
});
const SubtractMessage = /*#__PURE__*/styled(AddMessage).withConfig({
  displayName: "FieldList__SubtractMessage",
  componentId: "sc-140c85s-5"
})(["color:", ";font-size:", ";"], thunderBird, _ref4 => {
  let {
    scale
  } = _ref4;
  return FONT_SIZES[scale];
});
const AddContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "FieldList__AddContainer",
  componentId: "sc-140c85s-6"
})(["display:flex;justify-content:space-between;align-items:center;"]);
const CurrentMaxContainer = /*#__PURE__*/styled(AddMessage).withConfig({
  displayName: "FieldList__CurrentMaxContainer",
  componentId: "sc-140c85s-7"
})(["padding-right:.5em;color:", ";"], boulder);